<Select
  loaded={loaded(customer)}
  labelText="Zahlungsbedingungen"
  name="payment_conditions"
  selected={customer.payment_conditions}
  invalid={errors.payment_conditions !== undefined}
  invalidText={errors.payment_conditions}
  disabled={!meta?.permitted_attributes_for_update?.includes('payment_conditions')}
  on:input
>
  <SelectItem />
  {#each Object.entries(payment_conditions) as [key, value]}
    <SelectItem value={key} text={value} />
  {/each}
</Select>

<script lang="ts">
  import type { Customer, AttrErrors } from '../../models'
  import Select from '../../form/Select.svelte'
  import { SelectItem } from 'carbon-components-svelte'
  import { loaded } from '../../helper'
  import payment_conditions from '../../data/customer_payment_conditions.json'

  export let customer: Customer
  export let meta
  export let errors: AttrErrors
</script>
